import * as React from 'react';
import {
	FeatureSectionWrapper,
	InternalWrapper,
	PlaceholderRight,
	ImageWrapper,
	Image,
    RightContent,
    BackgroundVideo,
    ImagePlaceholder
} from './FeatureSectionStyles';
import {language} from './FeatureSectionLanguage'
import {CallToActionButtonLayout, Props as CTAProps} from "../../../../Components/CallToActionButton/CallToActionButtonLayout";

export type Props = {
	featureSection: any;
};

export const FeatureSectionLayout = (props: Props) =>
{
	const imageProps = {
		src: props.featureSection.foregroundImage,
	}

	const params = new URLSearchParams(window.location.search);
	const overrideFile = params.get("featureImage");

	let overrideStyle: any = undefined;

	if (overrideFile)
	{
		const defaultBg = "https://s3.ca-central-1.amazonaws.com/images.faizhirani.com/mariamrazi.com/0001.jpg";
		try {
			const bgUrl = new URL(defaultBg);
			const parts = bgUrl.pathname.split('/');
			parts[parts.length - 1] = overrideFile;
			bgUrl.pathname = parts.join('/');
			overrideStyle = { backgroundImage: `url('${bgUrl.toString()}')` };
		} catch (e) {
			console.error("Invalid override file:", e);
		}
	}

	const render = () =>
	{
		const ctaProps: CTAProps = {
			text: "Contact Me",
			href: "mailto:mariamrazi@gmail.com?subject=Hello&body=Just%20reaching%20out."
		}

		const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent.toLowerCase());

		const videoSrc = isSafari
			? "https://s3.ca-central-1.amazonaws.com/images.faizhirani.com/mariamrazi.com/backgroundVideo9.mov"
			: "https://s3.ca-central-1.amazonaws.com/images.faizhirani.com/mariamrazi.com/backgroundVideo5.webm";

		const returnValue = (
			<FeatureSectionWrapper style={overrideStyle}>
				<BackgroundVideo
					src={videoSrc}
					autoPlay
					muted
					loop
					playsInline
				/>
				<InternalWrapper>
					<PlaceholderRight />
					<RightContent>
						<CallToActionButtonLayout {...ctaProps} />
					</RightContent>
				</InternalWrapper>
			</FeatureSectionWrapper>
		);

		return returnValue;
	};
	const outerReturnValue = render();
	return outerReturnValue;
};
